export enum DropdownKind {
    CONFIRM = "confirm",
    DEFAULT = "default",
    DELETE = "delete",
    ICON = "icon",
    KEY = "key",
}
